export default __webpack_public_path__ + "static/hero_left-e016dcaf6077c3cd046348caa0d454b0.png";